var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "form",
      attrs: { novalidate: "" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
    },
    [
      _c("ValidationAlert", {
        attrs: { "error-list": _vm.errors.collect("server") },
      }),
      _vm._v(" "),
      _c(
        "fieldset",
        { staticClass: "form__group" },
        [
          _c("FormControlInsightCategory", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.formData.newCategory,
                expression: "!formData.newCategory",
              },
              {
                name: "validate",
                rawName: "v-validate",
                value: !_vm.formData.newCategory ? "required" : "",
                expression: "(!formData.newCategory) ? 'required' : ''",
              },
            ],
            attrs: { name: "folder", valueFormat: "object" },
            model: {
              value: _vm.formData.category,
              callback: function ($$v) {
                _vm.$set(_vm.formData, "category", $$v)
              },
              expression: "formData.category",
            },
          }),
          _vm._v(" "),
          [
            _vm.formData.newCategory
              ? _c(
                  "div",
                  [
                    _c("div", { staticClass: "form__group" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.formData.newName,
                            expression: "formData.newName",
                          },
                          { name: "validate", rawName: "v-validate" },
                        ],
                        staticClass: "form__control",
                        attrs: {
                          id: "new-name",
                          name: "newName",
                          placeholder: "Enter category name here...",
                          required: "",
                        },
                        domProps: { value: _vm.formData.newName },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.formData,
                              "newName",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form__label",
                          attrs: { for: "new-name" },
                        },
                        [_vm._v("Name")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "form__validation" }, [
                        _vm._v(_vm._s(_vm.errors.first("newName"))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("FormControlInsightCategory", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: _vm.formData.newCategory ? "required" : "",
                          expression:
                            "(formData.newCategory) ? 'required' : ''",
                        },
                      ],
                      attrs: { name: "newParent" },
                      model: {
                        value: _vm.formData.newParent,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "newParent", $$v)
                        },
                        expression: "formData.newParent",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          _vm._v(" "),
          _vm.can("createInsightCategories")
            ? _c("div", { staticClass: "form__group" }, [
                !_vm.formData.newCategory
                  ? _c(
                      "a",
                      {
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            _vm.formData.newCategory = true
                          },
                        },
                      },
                      [_vm._v("Create category")]
                    )
                  : _c(
                      "a",
                      {
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            _vm.formData.newCategory = false
                          },
                        },
                      },
                      [_vm._v("Use existing category")]
                    ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "form__group form__group--submit" }, [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "wait",
                    rawName: "v-wait:disabled",
                    value: "submit",
                    expression: '"submit"',
                    arg: "disabled",
                  },
                ],
                staticClass: "btn",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.back.apply(null, arguments)
                  },
                },
              },
              [_vm._v("Back")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "wait",
                    rawName: "v-wait:disabled",
                    value: "submit",
                    expression: '"submit"',
                    arg: "disabled",
                  },
                ],
                staticClass: "btn btn--primary",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.submit.apply(null, arguments)
                  },
                },
              },
              [_vm._v("Save & Continue")]
            ),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }